export default {
  CUSTOMER_DOCUMENTS_REPOSITORY: Symbol.for('CUSTOMER_DOCUMENTS_REPOSITORY'),
  REQUEST_UPDATE_CUSTOMER_DOCUMENT_INE_COMMAND: Symbol.for('REQUEST_UPDATE_CUSTOMER_DOCUMENT_INE_COMMAND'),
};
